var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"p-5"},_vm._l((_vm.components),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.toLowerCase(),"tag":"li"}},[_c('a',[_c('h5',[_vm._v(_vm._s(item))])])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }